import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BsBoxSeam } from "react-icons/bs";

import { CartonView } from "../../../../../../models/carton";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "../../../styles";

interface Props {
  carton?: CartonView;
  show?: boolean;

  closeCarton: (sscc?: string) => void;
}

const CloseButton = (props: Props) => {
  const { carton, show, closeCarton } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  const haveProducts = Number(carton?.products?.length) > 0;

  if (carton?.isClosed || !show) return null;

  return (
    <Grid item data-cy="close-sscc" className={classes.actionButton}>
      <DefaultTooltip
        title={
          !haveProducts
            ? translate("youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt")
            : translate("closeSSCC")
        }
      >
        <div onClick={haveProducts ? () => closeCarton(carton?.sscc) : undefined}>
          <BsBoxSeam size={18} color="#475467" />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default CloseButton;
